<template>
    <div id="app">
        <!-- <div class="info" style="height: 15%">
            <span>Center: {{ center }}</span>
            <span>Zoom: {{ zoom }}</span>
            <span>Bounds: {{ bounds }}</span>
        </div> -->
        <main class="main">
            <header class="header" :class="{'list-active': layout.listVisible}">
                <div v-if="!isApp" class="logo">
                    <img src="../src/assets/svg/die-presse.svg" alt="">
                    <hr class="separator">
                    <div class="title">Restaurantguide</div>
                    <div class="subtitle">Diese Lokale in Wien und Umgebung hat die "Presse"-Redaktion für Sie getestet.</div>
                </div>

                <div class="list-wrapper" :class="{'list-active': layout.listVisible}" :style="[ smallLayout && !isApp ? {'top': `${getLogoHeight()}px`, 'height': `calc(100% - ${getLogoHeight()}px)`} : '' ]">
                    <div v-show="layout.listVisible || !smallLayout" class="list" :style="{ padding: `${listPadding}px ${listPadding}px ${listPadding * 5}px ${listPadding}px` }">
                        <div v-for="(location, i) in locationObj.locations" :key="'list-' + i">
                            <div v-show="(location.isActive && ((location.isVisible) || activeFilterNum > 0))" class="card__wrapper" @click="zoomOnEl(location)">
                                <img v-lazy="resizeImg('card', location.img)" class="card__image lazy-img-fadein" :data-srcset="srcsetString(location.img)" />
                                <div class="card__content-wrapper">
                                    <div class="card__name">{{ location.name }}</div>
                                    <div class="card__address">{{ location.address }}</div>
                                    <div class="card__link"><a :href="'https://www.diepresse.com/' + location.articleId" target="_blank" @click="tracking('location', 'article click', location)">Zur Lokalkritik</a></div>
                                </div>
                            </div>
                            <div v-if="i === 0" id="abocontainer-rest1" class="piano-container"></div>
                            <div v-if="i === 4" id="abocontainer-rest2" class="piano-container"></div>
                        </div>
                        <div v-show="(locationObj.activeLocsSum === 0 || (locationObj.visibleLocsSum === 0 && activeFilterNum === 0)) && locationObj.locations.length > 0" class="no-result">
                            <div><img src="../src/assets/svg/no-search-result.svg" alt=""></div>
                            <div>Keine Treffer für diese Filter. Bitte verändern Sie Ihre Suche.</div>
                        </div>
                    </div>
                </div>
            </header>
            <div class="filter-wrapper">
                <div class="filter-menu__btn" :class="isApp && smallLayout && layout.listVisible && !filters.isShown ? 'list-active--app' : ''" @click="closeFilters()">
                    <div v-show="activeFilterNum > 0 && !filters.isShown" class="num">{{ activeFilterNum }}</div>
                    <img v-if="filters.isShown" src="../src/assets/svg/close.svg" alt="">
                    <img v-else src="../src/assets/svg/hamburger-menu.svg" alt="">
                </div>
                <LocationFilter v-show="filters.isShown" ref="locationFilter" :filters="filters" :geojson="geojson" :is-app="isApp" :style="[ smallLayout && !isApp ? {'top': getLogoHeight() + 'px'} : '' ]" @tracking="tracking"></LocationFilter>
            </div>
            <div class="map" :style="[ smallLayout && !isApp ? {'height': 'calc(100% - ' + getLogoHeight() + 'px'} : '' ]">
                <l-map ref="map" style="height: 100%; width: 100%" :options="{zoomControl: false}" :zoom="zoom" :center="center" @update:zoom="zoomUpdated" @update:center="centerUpdated" @update:bounds="boundsUpdated">
                    <l-control-zoom position="bottomright"></l-control-zoom>
                    <l-control-attribution position="bottomleft" :prefix="attribution"></l-control-attribution>
                    <l-tile-layer :url="url"></l-tile-layer>
                    <!-- <l-protobuf :url="url"></l-protobuf> -->
                    <l-marker-cluster>
                        <div v-for="(location, i) in locationObj.locations" :key="'marker-' + i">
                            <l-marker v-if="(location.isActive)" ref="markers" :icon="icon" :lat-lng="location.latLng" @click="clickOnMarker(location)">
                                <l-tooltip v-if="!isTouchDevice">{{ location.name }}</l-tooltip>
                                <l-popup ref="popups" :options="{ minWidth: 250, maxWidth: 250 }">
                                    <div class="popup__inner">
                                        <img v-lazy="resizeImg('popup', location.img)" class="popup__image lazy-img-fadein initial-height-popup" />
                                        <div class="popup__name">{{ location.name }}</div>
                                        <div class="popup__address">{{ location.address }}</div>
                                        <div class="popup__link"><a :href="'https://www.diepresse.com/' + location.articleId" target="_blank" @click="tracking('location', 'article click', location)">Zur Lokalkritik</a></div>
                                    </div>
                                </l-popup>
                            </l-marker>
                        </div>
                    </l-marker-cluster>
                    <l-geo-json :geojson="geojson.features" :options="geojson.options"></l-geo-json>
                </l-map>
            </div>

            <div v-show="smallLayout" class="switch__btn" @click="layout.listVisible = !layout.listVisible; filters.isShown = false;">
                {{ layout.listVisible ? 'Karte anzeigen' : 'Liste anzeigen' }}
            </div>
        </main>
    </div>
</template>

<script>

// import HelloWorld from './components/HelloWorld.vue'
import {LMap, LTileLayer, LMarker, LTooltip, LPopup, LControlZoom, LControlAttribution, LGeoJson } from 'vue2-leaflet';
import LMarkerCluster from 'vue2-leaflet-markercluster';
import L from 'leaflet';
import LocationFilter from './components/LocationFilter.vue';
import { pushDatalayer } from './helpers/trackingHelper';
import Cookies from 'js-cookie';
// import LProtobuf from 'vue2-leaflet-vectorgrid';

export default {
    name: 'App',
    components: {
        LMap,
        LTileLayer,
        LMarker,
        LMarkerCluster,
        LTooltip,
        LPopup,
        LControlZoom,
        LControlAttribution,
        LGeoJson,
        LocationFilter,
        // LProtobuf
    },
    data () {
        return {
            // url: 'https://stamen-tiles.a.ssl.fastly.net/terrain/{z}/{x}/{y}.jpg',
            // url: 'https://tiles.diepresse.com/styles/klokantech-basic/{z}/{x}/{y}.jpg',
            // url: 'https://basemaps.arcgis.com/v1/arcgis/rest/services/World_Basemap/VectorTileServer/tile/{z}/{y}/{x}.pbf',
            // url: 'http://{s}.tile.openstreetmap.de/{z}/{x}/{y}.png',
            // url: 'https://{s}.basemaps.cartocdn.com/rastertiles/voyager_labels_under/{z}/{x}/{y}.png',
            // url: 'http://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png',
            // url: 'https://maps.wikimedia.org/osm-intl/{z}/{x}/{y}.png',
            hash: window.location.hash.substring(1),
            zoom: 13,
            center: [48.210033, 16.363449],
            bounds: null,
            dataList: [],
            isLoaded: false,
            cardImgWidth: 300,
            popupImgWidth: 260,
            listPadding: 20,
            aspectRatio: 0.6,
            attribution: '<a style="color: dimgray;" href="https://www.openmaptiles.org/" target="_blank">© OpenMapTiles</a> <a style="color: dimgray;" href="https://www.openstreetmap.org/copyright" target="_blank">© OpenStreetMap contributors</a>',
            geojson: {
                features: null,
                options: {
                    style: {
                        'color': '#465168',
                        'weight': 4,
                        'opacity': 1,
                        'fillColor': '#dfe3f0',
                        'fillOpacity': 0.3
                    },
                    activeDistrict: null,
                    filter: function(feature) {
                        if(feature.properties.BEZNR === this.activeDistrict){
                            return true;
                        }
                    }
                }
            },
            layout: {
              listVisible: false
            },
            activeLocation: null,
            appDescription: 'Diese Lokale in Wien und Umgebung hat die "Presse"-Redaktion für Sie getestet.',
            filters: {
                query: '',
                activeDistrict: 0,
                type: {active: 'Alle Lokaltypen', list: ['Alle Lokaltypen'], isVisible: false, isActive: false},
                kitchen: {active: 'Alle Küchen', list: ['Alle Küchen'], isVisible: false, isActive: false},
                district: {active: 'Alle Bezirke', list: ['Alle Bezirke', '1. Innere Stadt', '2. Leopoldstadt', '3. Landstrasse', '4. Wieden', '5. Margareten', '6. Mariahilf', '7. Neubau', '8. Josefstadt', '9. Alsergrund', '10. Favoriten', '11. Simmering', '12. Meidling', '13. Hietzing', '14. Penzing', '15. Rudolfsheim-Fünfhaus', '16. Ottakring', '17. Hernals', '18. Währing', '19. Döbling', '20. Brigittenau', '21. Floridsdorf', '22. Donaustadt', '23. Liesing'],
                        isVisible: false, isActive: false},
                recommended: {name: 'empfohlen', value: false},
                breakfast: {name: 'Frühstück', value: false},
                budget: {name: 'budgetfreundlich', value: false},
                isShown: true
            },
            icon: L.icon({
                //iconUrl: 'https://assets.diepresse.com/layout/diepresse/files/restaurant-review-map/src/assets/images/icons/restaurant-pos.png',
                iconUrl: 'https://assets.diepresse.com/layout/diepresse/files/restaurant-review-map/src/assets/images/icons/restaurant-location.svg',
                iconSize: [42,42]
            }),
            latLongList: []
        };
    },
    computed: {
        url(){
            let url = '';
            switch (this.hash) {
                case 'klokantech-basic':
                    url = 'https://tiles.diepresse.com/styles/klokantech-basic/{z}/{x}/{y}.png';
                    break;
                case 'osm-bright':
                    url = 'https://tiles.diepresse.com/styles/osm-bright/{z}/{x}/{y}.png';
                    break;
                default:
                    url = 'https://tiles.diepresse.com/styles/klokantech-basic/{z}/{x}/{y}.png';
            }
            return url;
        },
        locationObj(){
            let obj = {
                locations: this.dataList,
                visibleLocsSum: 0,
                activeLocsSum: 0
            };

            for (let i = 0; i < obj.locations.length; i++){

                // filter locations
                if ((this.filters.type.active === 'Alle Lokaltypen' || this.filters.type.active === obj.locations[i].type[0] || this.filters.type.active === obj.locations[i].type[1]) &&
                (this.filters.kitchen.active === 'Alle Küchen' || this.filters.kitchen.active === obj.locations[i].kitchen[0] || this.filters.kitchen.active === obj.locations[i].kitchen[1]) &&
                (this.filters.district.active === 'Alle Bezirke' || this.filters.district.active === obj.locations[i].district) &&
                (!this.filters.recommended.value || (this.filters.recommended.value && obj.locations[i].recommended)) &&
                (!this.filters.breakfast.value || (this.filters.breakfast.value && obj.locations[i].breakfast)) &&
                (!this.filters.budget.value || (this.filters.budget.value && obj.locations[i].budget))){
                    obj.locations[i].isActive = true;
                    obj.locations[i].pos = obj.activeLocsSum;
                    obj.activeLocsSum++;
                } else {
                    obj.locations[i].isActive = false;
                }

                // is location visible
                // this.bounds !== null ? console.log(this.bounds.contains([parseFloat(arr[i].latLng[0]), parseFloat(arr[i].latLng[1])])) : this.bounds;
                if(this.dataList.length !== 0 && this.bounds !== null && this.bounds.contains([parseFloat(obj.locations[i].latLng[0]), parseFloat(obj.locations[i].latLng[1])])){
                    obj.locations[i].isVisible = true;
                    obj.visibleLocsSum++;
                } else {
                    obj.locations[i].isVisible = false;
                }


            }

            return obj;
        },
        activeFilterNum(){
            let arr = [this.filters.district.active !== 'Alle Bezirke', this.filters.type.active !== 'Alle Lokaltypen', this.filters.kitchen.active !== 'Alle Küchen', this.filters.recommended.value, this.filters.breakfast.value, this.filters.budget.value];
            let activeNum = 0;
            for(var i=0;i<arr.length;i++){
                if(arr[i] === true)
                    activeNum++;
            }
            return activeNum;
        },
        smallLayout(){
            return (this.$mq === 'tablet' || this.$mq === 'mobile');
        },
        isTouchDevice(){
            return (('ontouchstart' in window) ||
                (navigator.maxTouchPoints > 0) ||
                (navigator.msMaxTouchPoints > 0));
        },
        activeFilterArr(){
            return [this.filters.type.active,  this.filters.kitchen.active, this.filters.district.active,  this.filters.budget.value];
        },
        isApp(){
            // check if TA set the Cookie for the webview
            return Cookies.get('_ta_referer') === 'http://pc_mobile_app';
        }
    },
    watch: {
        activeFilterArr: {
            handler(val){

                this.setActiveLocation(null, false);

                let labelArr = [], queryArr = [], districtStr;

                if(val[0] !== 'Alle Lokaltypen'){ labelArr.push(val[0]); queryArr.push({ key: 'type', value: val[0] }); }
                if(val[1] !== 'Alle Küchen'){ labelArr.push(val[1]); queryArr.push({ key: 'kitchen', value: val[1] }); }
                if(val[2] !== 'Alle Bezirke'){ districtStr = (val[2].indexOf('.') === 1 ? '10' + val[2].slice(0, 1) + '0' : '1' + val[2].slice(0, 2) + '0') + ' Wien'; labelArr.push(districtStr); queryArr.push({ key: 'district', value: val[2] }); }
                if(val[3]){ labelArr.push('budgetfreundlich'); queryArr.push({ key: 'budget', value: true }); }

                let filterTitle = labelArr.join(' · ');
                let label = labelArr.join(' | ');

                this.setTitle(filterTitle);
                this.setDescription(this.appDescription);
                this.setUrlQueryString(queryArr);
                if (label.length > 0) this.tracking('filter', label);
            },
            deep: true
        }
    },
    async created () {
        this.fetchData();

        const response = await fetch('https://assets.diepresse.com/layout/diepresse/files/cds/wien-magazin/json/district-borders.json');
        this.geojson.features = await response.json();
    },
    mounted: function(){
        this.bounds = this.$refs.map.mapObject.getBounds();
        this.$nextTick(function () {
            this.isLoaded = true;

            if (this.smallLayout){
                this.filters.isShown = false;
            }

            this.setCardImgWidth();
            this.setCardImgHeight();

            /* window.addEventListener('resize', () => {
                this.setCardImgWidth();
            }); */

        });
    },
    methods: {
        getLogoHeight(){
            return document.querySelector('.logo').offsetHeight;
        },
        setTitle(str){
            let title = str + (str.length > 0 ? ' | ' : '') + 'Restaurantguide | Die Presse';
            document.title = title;
            document.querySelector('meta[property=og\\:title]').setAttribute('content', title);
            document.querySelector('meta[name=twitter\\:title]').setAttribute('content', title);
        },
        setDescription(description){
            document.querySelector('meta[name=description]').setAttribute('content', description);
        },
        setActiveLocation(location, changeMeta){
            this.activeLocation = location;

            if (location !== null){
                this.setUrlQueryString([{ key: 'locationName', value: location.name }]);
            } else {
                this.setUrlQueryString([]);
            }

            if(changeMeta){
                if (location === null){
                    this.setTitle('');
                    this.setDescription(this.appDescription);
                } else {
                    let teaser = location.teaser.replace(/<\/?[^>]+(>|$)/g, '');
                    this.setTitle(location.name);
                    this.setDescription(teaser);
                }
            }
        },
        sendTracking(action, label, name, address, plz, type, cuisine, event){
            pushDatalayer({
                'eventCategory': 'restaurant guide',
                'eventAction': action,
                'eventLabel': label,
                'lg.rest.guide.name': name,
                'lg.rest.guide.address': address,
                'lg.rest.guide.plz': plz,
                'lg.rest.guide.local.type': type,
                'lg.rest.guide.local.cuisine': cuisine,
                'event': event
            });
        },
        setCardImgWidth(){
            if(this.smallLayout){
                this.cardImgWidth = window.innerWidth - (2 * this.listPadding);
            } else {
                let list = document.querySelector('.list');
                this.cardImgWidth = list.clientWidth - (2 * this.listPadding);
            }
        },
        setCardImgHeight(){
            let vue = this;
            this.$Lazyload.$on('loading', function ({ el }) {
                if(el.classList.contains('card__image')){
                    el.style.height = vue.cardImgWidth * vue.aspectRatio + 'px';
                }
            });

            this.$Lazyload.$on('loaded', function ({ el }) {
                if(el.classList.contains('card__image')){
                    el.style.height = 'auto';
                }
            });
        },
        clickOnMarker(location){
            this.setActiveLocation(location, true);
            this.tracking('location', 'map click location', location);
            setTimeout(() => {
                this.setCloseBtnFunctions();
            }, 500);
        },
        tracking(type, label, location){
            switch(type) {
                case 'location':
                    this.sendTracking('restaurant', label, location.name, location.address, location.plz, location.type, location.kitchen, 'lg.restaurant.guide.click');
                    break;
                case 'filter':
                    this.sendTracking('filter', label, 'not-set', 'not-set', 'not-set', 'not-set', 'not-set', 'lg.restaurant.guide.filter');
                    break;
                case 'feature':
                    this.sendTracking('others', label, 'not-set', 'not-set', 'not-set', 'not-set', 'not-set', 'lg.restaurant.guide.feature');
                    break;
            }
        },
        resizeImg(type, path){
            let splitPath = path.split('/');

            for (let i = 0; i < splitPath.length; i++){
                if(splitPath[i].indexOf('uploads') > -1){
                    if (type === 'card'){
                        splitPath[i] = 'uploads';
                    } else {
                        splitPath[i] = 'uploads_' + this.popupImgWidth;
                    }
                }
            }
            let newPath = 'https://media.diepresse.com' + splitPath.join('/');
            return newPath; // + '?' + Date.now();
        },
        srcsetString(path){
            let str = '';
            let wArr = ['200', '250', '300', '350', '400', '450', '500', '550', '600', '650', '700', '750', '800', '850', '900', '950', '1000'];
            let splitPath = path.split('/');
            let startPath, endPath;

            for (let i = 0; i < splitPath.length; i++){
                if(splitPath[i].indexOf('uploads') > -1){
                    startPath = splitPath.slice(0, i).join('/');
                    endPath = splitPath.slice(i + 1).join('/');
                }
            }

            for (let i = 0; i < wArr.length; i++){
                str += 'https://media.diepresse.com' + startPath + '/uploads_' + wArr[i] + '/' + endPath + ' ' + wArr[i] + 'w, ';
            }

            return str;
        },
        zoomUpdated (zoom) {
            this.zoom = zoom;
            setTimeout(() => {
                if(this.activeLocation && !this.$refs.popups[this.activeLocation.pos].mapObject.isOpen()){
                    this.setActiveLocation(null, true);
                }
            }, 1000);
        },
        centerUpdated (center) {
            this.center = center;
        },
        boundsUpdated (bounds) {
            this.bounds = bounds;
        },
        zoomOnEl(location){
            this.setActiveLocation(location, true);
            this.$refs.map.mapObject.setView(location.latLng, 18);

            if (this.smallLayout){
                this.filters.isShown = false;
                this.layout.listVisible = false;
            }

            setTimeout(() => {
                this.$refs.markers[location.pos].mapObject.openPopup();
            }, 500);

            setTimeout(() => {
                this.setCloseBtnFunctions();
            }, 1000);

            this.tracking('location', 'overview click', location);
        },
        closeFilters(){
            this.filters.isShown = !this.filters.isShown;

            this.filters.type.isVisible = false;
            this.filters.kitchen.isVisible = false;
            this.filters.district.isVisible = false;

            if(this.filters.isShown){
                this.tracking('feature', 'filter open');
            } else {
                this.tracking('feature', 'filter close');
            }
        },
        fetchData () {

            fetch('https://assets.diepresse.com/layout/diepresse/files/restaurant-review-map/restaurant-critics.json')
                .then(response => response.json())
                .then(response => {
                    response.values.shift();
                    let list = [];
                    for (let i = 0; i < response.values.length; i++){
                        if(response.values[i][12] !== undefined && response.values[i][12].length > 1){

                            list.push({
                                index: i,
                                isActive: false,
                                isVisible: false,
                                name: response.values[i][8],
                                img: response.values[i][6],
                                articleId: response.values[i][0],
                                teaser: response.values[i][5],
                                address: response.values[i][11] + ' ' +  response.values[i][9] + ' ' + response.values[i][10],
                                plz: response.values[i][10],
                                district: response.values[i][10][0] === '1' ? this.filters.district.list[parseInt(response.values[i][10].substring(1,3), 10)] : 'Alle Bezirke',
                                latLng: [response.values[i][12], response.values[i][13]],
                                type: [response.values[i][17], response.values[i][18]],
                                kitchen: [response.values[i][19], response.values[i][20]],
                                recommended: response.values[i][21] !== undefined ? response.values[i][21].toLowerCase().indexOf('empfohlen') > -1 : false,
                                breakfast: response.values[i][21] !== undefined ? response.values[i][21].toLowerCase().indexOf('frühstück') > -1 : false,
                                budget: response.values[i][21] !== undefined ? response.values[i][21].toLowerCase().indexOf('budgetfreundlich') > -1 : false
                            });

                        }
                    }
                    this.dataList = list;
                })
                .then(() => {
                    this.fetchCategories();
                });
        },
        fetchCategories () {

            fetch('https://assets.diepresse.com/layout/diepresse/files/restaurant-review-map/restaurant-categories.json')
                .then(response => response.json())
                .then(response => {
                    response.values.shift();
                    for(let i = 0; i < response.values.length; i++){
                        if (response.values[i][0] !== undefined) this.filters.kitchen.list.push(response.values[i][0]);
                        if (response.values[i][1] !== undefined) this.filters.type.list.push(response.values[i][1]);
                    }
                }).then(() =>{
                    this.getUrlQueryString();
                });
        },
        fetchLatLng () {
            for(let i = 0; i < 200; i++){
                let thisLoc = this.locationObj[i].address;
                let param = encodeURIComponent(thisLoc.trim());
                let vue = this;

                setTimeout(function(){
                    fetch('https://api.opencagedata.com/geocode/v1/json?q=' + param + '&key=0cf600273ef04c0ab25d6277a323f1b1&language=de&pretty=1')
                        .then(response => response.json())
                        .then(response => {
                            vue.latLongList.push(response.results[0].geometry);
                        });
                }, 1300 * i);
            }
        },
        getUrlQueryString(){

            const urlSearchParams = new URLSearchParams(window.location.search);
            const params = Object.fromEntries(urlSearchParams.entries());

            for (const [key, value] of Object.entries(params)) {

                if(key in this.filters && (!this.filters[key].list || this.filters[key].list.indexOf(value) > -1)) {

                    switch (key) {
                        case 'type':
                        case 'kitchen':
                            this.filters[key].active = value;
                            this.filters[key].isActive = true;
                            break;
                        case 'district':
                            this.$refs.locationFilter.filterDistrict('district', value, this.filters['district'].list.indexOf(value));
                            break;
                        case 'recommended':
                        case 'breakfast':
                        case 'budget':
                            this.filters[key].value = true;
                            break;
                    }
                }

                if (key === 'articleId' || key === 'locationName'){

                    for(let i = 0; i < this.dataList.length; i++){
                        if (this.dataList[i].articleId === value || this.dataList[i].name === value){

                            this.zoomOnEl(this.dataList[i]);

                        }
                    }

                }
            }
        },
        setUrlQueryString(arr){
            const params = new URLSearchParams(window.location.search);
            const paramsObj = Object.fromEntries(params.entries());

            for (const [key] of Object.entries(paramsObj)) {
                params.delete(key);
            }

            if(arr.length > 0){
                for (let i = 0; i < arr.length; i++){
                    params.set(arr[i].key, arr[i].value);
                }
            }

            params.toString();
            window.history.replaceState({}, '', `${window.location.pathname}?${params.toString()}`);

        },
        setCloseBtnFunctions(){
            let closeBtn = document.querySelector('.leaflet-popup-close-button');
            closeBtn.addEventListener('click', () => {
                this.setActiveLocation(null, true);
                this.tracking('feature', 'restaurant close');
            });
        }
    }
};
</script>

<style lang="scss">
    @import "~leaflet.markercluster/dist/MarkerCluster.css";
    @import "~leaflet.markercluster/dist/MarkerCluster.Default.css";
    @import 'assets/sass/main';
</style>
